import { createContext, useContext } from 'react';

export const SlideThemeCtx = createContext<{ elementColorSet?: string }>({});

export const useThemeContext = () => {
  return useContext(SlideThemeCtx);
};
